import { render, staticRenderFns } from "./company-association.vue?vue&type=template&id=28d964f6&"
import script from "./company-association.vue?vue&type=script&lang=js&"
export * from "./company-association.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports